<template>

    <div>
        <b-tabs id="note-tabs" type="is-toggle" expanded>
            
            <b-tab-item>
                <!-- custom header to show count -->
                <template slot="header">
                    <b-icon icon="door-open"></b-icon>
                    <span>Open <b-tag class="count-tag" v-if="OpenCount" rounded>{{OpenCount}} </b-tag> </span>
                </template>
                <div
                    v-for="note in FilterLessThanStatus(2)"
                    v-bind:key="note.id">
                    <note-card :note="note"></note-card>
                </div>
            </b-tab-item>

            <b-tab-item>
                <template slot="header">
                    <b-icon icon="door-closed"></b-icon>
                    <span>Closed <b-tag class="count-tag" rounded>{{ClosedCount}} </b-tag> </span>
                </template>
                <div
                    v-for="note in FilterNotesStatusEquals(2)"
                    v-bind:key="note.id">
                    <note-card :note="note"></note-card>
                </div>
            </b-tab-item>

            <b-tab-item>
                <template slot="header">
                    <b-icon icon="ball-pile"></b-icon>
                    <span>All <b-tag class="count-tag" rounded>{{AllCount}} </b-tag> </span>
                </template>
                <note-card
                    v-for="note in notes"
                    v-bind:key="note.id"
                    :note="note"
                    >
                ></note-card>
            </b-tab-item>

        </b-tabs>
    </div>

</template>


<script>
    export default {
        data() {
            return {
            }
        },
        props: {
            notes : Array,
        },
        computed: {
            OpenCount() {
                // Filter js method
                let filtered = this.notes.filter(function(note) {
                    return note.status < 2;
                })
                return filtered.length
            },
            ClosedCount() {
                let filtered = this.notes.filter(function(note) {
                    return note.status > 1;
                })
                return filtered.length
            },
            AllCount() {
                return this.notes.length
            }
        },
        methods: {
            FilterNotesStatusEquals(status) {
                return this.notes.filter(note => note.status === status)
            },
            FilterLessThanStatus(status) {
                return this.notes.filter(note => note.status < status)
            }
        },
        created() {
        },
    }

</script>


<style scoped lang="scss">
    @import "../styles/_variables.scss";

    #note-tabs{
        background: $den_bg_lighter;
        margin: 1em;
    }
    .count-tag {
        background: $den_offwhite;
        color: $den_text_dark;
    }
</style>
